export default {
  namespaced: true,
  state: {
    currentOrderDetail: {}
  },
  mutations: {
    setCurrentOrderDetail(state, currentOrderDetail) {
      state.currentOrderDetail = currentOrderDetail;
    }
  }
};
